import HelixPalette from './palette';
// Base font family.
const fontBase = {
    fontFamily: '"Gilroy", Verdana, sans-serif',
};
// Base text style using the base font and neutral90.
const textBase = Object.assign(Object.assign({}, fontBase), { color: HelixPalette.neutral90 });
// Font sizes.
const varBase = '1rem';
const var10 = '0.625rem';
const var12 = '0.75rem';
const var13 = '0.8125rem';
const var14 = '0.875rem';
const var18 = '1.125rem';
const var20 = '1.25rem';
const var22 = '1.375rem';
const styles = {
    style_01: Object.assign(Object.assign({}, textBase), { fontSize: var22, fontWeight: 700 }),
    style_02: Object.assign(Object.assign({}, textBase), { fontSize: var20, fontWeight: 700 }),
    style_03: Object.assign(Object.assign({}, textBase), { fontSize: var18, fontWeight: 700 }),
    style_04: Object.assign(Object.assign({}, textBase), { fontSize: var14, fontWeight: 700 }),
    style_05: Object.assign(Object.assign({}, textBase), { fontSize: var12, fontWeight: 700 }),
    style_06: Object.assign(Object.assign({}, textBase), { fontSize: varBase, fontWeight: 400 }),
    style_06_compact: Object.assign(Object.assign({}, textBase), { fontSize: varBase, fontWeight: 400 }),
    style_06_medium: Object.assign(Object.assign({}, textBase), { fontSize: varBase, fontWeight: 500 }),
    style_07: Object.assign(Object.assign({}, textBase), { fontSize: var14, fontWeight: 500, lineHeight: '125%' }),
    style_08: Object.assign(Object.assign({}, textBase), { fontSize: var18, fontWeight: 700, lineHeight: '1.5rem' }),
    style_09: Object.assign(Object.assign({}, textBase), { fontSize: varBase, fontWeight: 700, lineHeight: '1.25rem' }),
    style_10: Object.assign(Object.assign({}, textBase), { fontSize: var14, fontWeight: 700, lineHeight: '1rem' }),
    style_11: Object.assign(Object.assign({}, textBase), { fontSize: var13, fontWeight: 400 }),
    style_11_bold: Object.assign(Object.assign({}, textBase), { fontSize: var13, fontWeight: 700, lineHeight: '1rem' }),
    style_12: Object.assign(Object.assign({}, textBase), { fontSize: var12, fontWeight: 400 }),
    style_12_wide: Object.assign(Object.assign({}, textBase), { fontSize: var12, fontWeight: 700 }),
    style_13: Object.assign(Object.assign({}, textBase), { fontSize: var10, fontWeight: 400 }),
};
const elevations = {
    elevationXS: '0.0px 0.0px 0.0px 0px rgba(0, 0, 0, 0.05)',
    elevationSM: '0.0px 1.0px 2.0px 0px rgba(0, 0, 0, 0.05)',
    elevationBASE: '0.0px 1.0px 3.0px 0px rgba(0, 0, 0, 0.1),0.0px 1.0px 2.0px 0px rgba(0, 0, 0, 0.06)',
    elevationMD: '0.0px 0.0px 6.0px 0px rgba(0, 0, 0, 0.02),0.0px 1.0px 8.0px 0px rgba(0, 0, 0, 0.1),0.0px 2.0px 4.0px 0px rgba(0, 0, 0, 0.15)',
    elevationLG: '0.0px 8.0px 15.0px 0px rgba(0, 0, 0, 0.19),0.0px 1.0px 6.0px 0px rgba(0, 0, 0, 0.12)',
    elevationXL: '0.0px 20.0px 25.0px 0px rgba(0, 0, 0, 0.1),0.0px 10.0px 10.0px 0px rgba(0, 0, 0, 0.04)',
    elevation2XL: '0.0px 25.0px 50.0px 0px rgba(0, 0, 0, 0.25)',
};
const outlines = {
    focusVisible1: `0 0 0 1px ${HelixPalette.white}, 0 0 0 3px ${HelixPalette.blue70}`,
    focusVisible2: `0 0 0 2px ${HelixPalette.blue70}`,
    focusVisible3: `-1px -1px -1px 2px ${HelixPalette.blue70}`,
    focusVisible4: { outline: `solid ${HelixPalette.blue70} 2px`, outlineOffset: '2px', },
    focusVisible5: { outline: `solid ${HelixPalette.blue70} 2px`, outlineOffset: '1px', },
    focusVisible6: { outline: `solid ${HelixPalette.blue70} 1px`, outlineOffset: '-1px', },
    focusVisible7: { outline: `solid ${HelixPalette.blue70} 2px`, outlineOffset: '-2px', }
};
export default Object.assign(Object.assign(Object.assign(Object.assign({}, elevations), outlines), styles), { fontBase,
    textBase, truncate: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    } });
